import React, { useEffect, useRef, useState, useCallback } from "react";
import styled from "styled-components";

const GridContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  background-color: transparent;
`;

const ShapeGrid = ({
  shape = "square", // square, circle, hexagon
  squareSize = 50,
  borderColor = "rgba(133, 76, 230, 0.1)",
  hoverFillColor = "rgba(133, 76, 230, 0.2)",
  hoverTrailAmount = 3,
  animationSpeed = 1,
  direction = "right",
}) => {
  const containerRef = useRef(null);
  const [grid, setGrid] = useState({ rows: 0, cols: 0 });
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const calculateGrid = useCallback(() => {
    if (containerRef.current) {
      const { width, height } = containerRef.current.getBoundingClientRect();
      const cols = Math.ceil(width / squareSize);
      const rows = Math.ceil(height / squareSize);
      setGrid({ rows, cols });
    }
  }, [squareSize]);

  useEffect(() => {
    calculateGrid();
    window.addEventListener("resize", calculateGrid);
    return () => window.removeEventListener("resize", calculateGrid);
  }, [calculateGrid]);

  const renderShape = (index) => {
    const isHovered = hoveredIndex === index;
    const style = {
      width: squareSize,
      height: squareSize,
      border: `1px solid ${borderColor}`,
      boxSizing: "border-box",
      transition: "background-color 0.4s ease, border-color 0.4s ease",
      backgroundColor: isHovered ? hoverFillColor : "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    if (shape === "circle") {
      style.borderRadius = "50%";
    }

    return (
      <div
        key={index}
        style={style}
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
      />
    );
  };

  return (
    <GridContainer ref={containerRef}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${grid.cols}, ${squareSize}px)`,
          gridTemplateRows: `repeat(${grid.rows}, ${squareSize}px)`,
          width: "max-content",
          height: "max-content",
        }}
      >
        {Array.from({ length: grid.rows * grid.cols }).map((_, i) =>
          renderShape(i)
        )}
      </div>
    </GridContainer>
  );
};

export default ShapeGrid;
